import { CorporateTDAEInformationApi } from '@blank/api'
import { apiClient } from 'modules/common/http/apiClient'
import { getAuthorizationHeader } from 'modules/common/lib/api/getAuthorizationHeader'

interface Props {
  corporateId: string
  accessToken: string
}
export const fetchCorporateTDAEInformation = async ({
  corporateId,
  accessToken,
}: Props) => {
  const { data } = await apiClient.get<CorporateTDAEInformationApi>(
    `/v1/bservices/${corporateId}/tdae/info`,
    {
      headers: getAuthorizationHeader(accessToken),
    }
  )

  return data
}
